module.exports = __webpack_public_path__ + "static/single_provider-33248e6944cdc20a5a6413e6a6ce8b1e.svg";